var exports = {
  "i1": "InterfaceTab.module__previewContainer___MnhVY1",
  "gp": "InterfaceTab.module__previewContent___MnhVY1",
  "rv": "InterfaceTab.module__tooltipContent___MnhVY1",
  "zX": "InterfaceTab.module__typingContainer___MnhVY1",
  "ro": "InterfaceTab.module__typingAnimationWrapper___MnhVY1",
  "OI": "InterfaceTab.module__typingAvatars___MnhVY1",
};

module.exports = exports;
